// client/src/components/crowdfunding/TeacherRecommendation.tsx

import React, { useState } from "react";
import { createRecommendation } from "../../services/crowdfundingService";
import "../../assets/styles/crowdfunding.css";

const TeacherRecommendation: React.FC = () => {
  const [teacherName, setTeacherName] = useState<string>("");
  const [teacherEmail, setTeacherEmail] = useState<string>("");
  const [recommendation, setRecommendation] = useState<string>("");
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!teacherName || !teacherEmail || !recommendation) {
      setError("All fields are required.");
      return;
    }

    setError(null);
    setLoading(true);

    // Replace these dummy values with real data from context or props.
    const payload = {
      applicationId: "dummy-application-id",
      teacherId: "dummy-teacher-id",
      content: recommendation,
    };

    try {
      const result = await createRecommendation(payload);
      console.log("Teacher Recommendation Created:", result);
      setSubmitted(true);
    } catch (err: any) {
      setError(err.message || "Failed to submit recommendation.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="teacher-recommendation">
      <h2>Teacher Recommendation</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {submitted ? (
        <p style={{ color: "green" }}>Recommendation submitted successfully!</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <div>
            <label>Teacher Name:</label>
            <input
              type="text"
              value={teacherName}
              onChange={(e) => setTeacherName(e.target.value)}
              placeholder="Enter teacher's name"
              required
            />
          </div>
          <div>
            <label>Teacher Email:</label>
            <input
              type="email"
              value={teacherEmail}
              onChange={(e) => setTeacherEmail(e.target.value)}
              placeholder="Enter teacher's email"
              required
            />
          </div>
          <div>
            <label>Recommendation:</label>
            <textarea
              value={recommendation}
              onChange={(e) => setRecommendation(e.target.value)}
              placeholder="Enter the teacher's recommendation"
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit Recommendation"}
          </button>
        </form>
      )}
    </div>
  );
};

export default TeacherRecommendation;
